export default __webpack_public_path__ + "static/media/1161.fc1a34a6.JPG";